import { SxProps, Theme } from '@mui/material'

export const launchpadLogoSx: SxProps<Theme> = {
  width: '12.7rem',
  height: '7rem',
}

export const ctaTextSx: SxProps<Theme> = {
  color: (theme) => theme.palette.primary.contrastText,
  textAlign: {
    lg: 'left',
    xs: 'center',
  },
  letterSpacing: {
    lg: '0.06rem',
    xs: 0,
  },
  lineHeight: {
    lg: '5.7rem',
    md: '4rem',
    xs: '3.2rem',
  },
  fontSize: {
    lg: '4.8rem',
    md: '3.4rem',
    xs: '2.4rem',
  },
  fontWeight: {
    md: 700,
    xs: 500,
  },
}

export const contentSx: SxProps<Theme> = {
  maxWidth: {
    xs: '100%',
    lg: '46.8rem',
    xl: '70.8rem',
  },
  display: 'flex',
  flexDirection: 'column',
  alignItems: {
    xs: 'center',
    lg: 'start',
  },
  gap: {
    lg: '4rem',
    xs: '2.4rem',
  },
  marginLeft: { lg: 'auto' },
  margin: {
    xs: '0 auto',
    md: 0,
  },
}

export const containerSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: { xs: 'center', lg: 'initial' },
  height: 'auto',
  background: 'linear-gradient(180deg, #184A9B 0%, #03378B 100%)',
  backgroundSize: 'cover',
  padding: { xs: '2.4rem', md: '2.4rem 5.6rem', lg: '0 12.6rem' },
}

export const buttonSx: SxProps<Theme> = {
  alignSelf: { xs: 'stretch', md: 'center', lg: 'flex-start' },
}
